import { useQuery } from '@tanstack/react-query';

import { IS_PRODUCTION_APP } from 'src/app/constants/environment';
import { getData } from 'src/app/queries';

import type { QueryKey } from '@tanstack/react-query';

export const GET_BUILD_NUMBER = 'api/admin/get-build-number';

const buildNumberQueryKey: QueryKey = ['build'];

type GetBuildNumberResponse = {
  BuildNumber: string;
  ForceRefresh: boolean;
  VersionNumber: string;
};

export function useBuildNumber() {
  // Production: 10 minutes (600000ms), Development/Test: 5 seconds (5000ms) for faster testing
  const interval = IS_PRODUCTION_APP ? 600000 : 5000;

  return useQuery({
    queryKey: buildNumberQueryKey,
    queryFn: () => getData<GetBuildNumberResponse>(GET_BUILD_NUMBER),
    refetchInterval: interval,
  });
}
